 
class Profile { 
     
    public static campos = () => {
        return [ 
            {
                nome: "nome",
                type: "text",
                label: "Nome",
                sm: 6 ,
                lg: 6, 
                xxl: 6, 
                disabled: true
            },  
            {
                nome: "id",
                type: "text",
                label: "CPF",
                sm: 6 ,
                lg: 2, 
                xxl: 2, 
                disabled: true
            },  
            {
                nome: "situacao",
                type: "text",
                label: "Situação",
                sm: 6 ,
                lg: 2, 
                xxl: 2, 
                disabled: true
            }, 
            {
                nome: "dataNascimento",
                type: "date",
                label: "Nascimento",
                sm: 6 ,
                lg: 2, 
                xxl: 2, 
                disabled: true
            }, 
            {
                nome: "unidade",
                type: "text",
                label: "Unidade",
                sm: 6 ,
                lg: 3, 
                xxl:3, 
                disabled: true
            }, 
            {
                nome: "situacao",
                type: "text",
                label: "Situacao RH",
                sm: 6 ,
                lg: 3, 
                xxl: 3, 
                disabled: true
            }, 
             
            {
                nome: "rg",
                type: "number",
                label: "RG ( somente números )",
                sm: 6 ,
                lg: 3, 
                xxl: 3, 
                disabled: true
            },  
            {
                nome: "numeroFuncional",
                type: "number",
                label: "NF  ( somente números )",
                sm: 6 ,
                lg: 3, 
                xxl: 3, 
                disabled: true
            },  
            {
                nome: "celular",
                type: "text",
                label: "Celular",
                sm: 6 ,
                lg: 3, 
                xxl: 3, 
                disabled: false
            },   
            {
                nome: "nomeGuerra",
                type: "text",
                label: "Nome de Guerra",
                sm: 6 ,
                lg: 3, 
                xxl: 3, 
                disabled: false
            },  
            {
                nome: "sexo",
                type: "select",
                label: "Sexo",
                sm: 6 ,
                lg: 3, 
                xxl: 2, 
                disabled: true,
                options:  [ {value:"M",label:'MASCULINO'} , {value:"F", label:'FEMININO' } ] 
            },  
            {
                nome: "email",
                type: "text",
                label: "Email",
                sm: 6 ,
                lg: 6, 
                xxl: 4, 
                disabled: false
            },  
           
        ];
    }   
} 
export   {   Profile }; 